<template>
  <div class="home">
    <h1 class="center">home {{user && user.defaultCurrency && user.defaultCurrency.symbol}}</h1>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { USER_INFO } from "../store/constants";

export default {
  name: "home",
  computed: {
    ...mapState({
      user: state => state.auth[USER_INFO]
    })
  }
};
</script>
<style lang="less" scoped>
@import "../styles/variables.less";
form {
  text-align: left;
  max-width: 640px;
  margin: 0 auto;
}
</style>
